// Viewport fix
import Alpine from 'alpinejs';
import addWindowScrollPositionToDocument from './modules/viewport';

// Alpine

// Add Lottie player
import '@lottiefiles/lottie-player';

// Custom modules
import CookieConsent from './modules/cookie-consent';
import initFoodSlider from './modules/food-slider';
import initQuickNav from './modules/quick-nav';
import initOpeningHoursNav from './modules/opening-hours-nav';
import initDownloadMenukaarten from './modules/download-menukaarten';

addWindowScrollPositionToDocument();
window.Alpine = Alpine;
Alpine.start();

initFoodSlider();
initQuickNav();
initOpeningHoursNav();
initDownloadMenukaarten();

// Fix for alpine js menu
const siteHeader = document.querySelector('[data-site-header]');

window.onload = () => {
    siteHeader.classList.remove('hidden');

    const cookieConsent = new CookieConsent(document);

    if (document.querySelector('[data-inova-cookie-notice]') !== null) {
        setTimeout(() => cookieConsent.showNotice(), 2000);
    } else if (document.querySelector('button.update-cookie-settings') !== null) {
        document.querySelector('button.update-cookie-settings').addEventListener('click', () => {
            cookieConsent.showSettings().then(() => {
            });
        });
    }
};
